// config.js di cms_prod
const defaultURL = "https://api.bintangsempurna.co.id";
// config local
// const defaultURL = "http://127.0.0.1:8000";

export default defaultURL;
